<ng-container>
    <div (mouseleave)="overlayInput.isOpen = false"
        (mouseenter)="overlayInput.isOpen = true" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <mat-icon>
            {{ overlayInput.icon }}
        </mat-icon>
    </div>
</ng-container>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="overlayInput.isOpen">
    <div class="widget-container-button">
        <ng-content></ng-content>
    </div>
</ng-template>